import styled from "styled-components";

export const Styles = styled.div`
    .title {
        font-family: IRANSans;
        font-style: normal;
        font-weight: 800;
        font-size: 40px;
        line-height: 46px;
        letter-spacing: -0.03em;
        font-feature-settings: "pnum" on, "onum" on;
        color: #1a1a1c;
        padding-bottom: 20px;
        padding-top: 30px;
    }

    .subtitle {
        font-family: IRANSans;
        font-style: normal;
        font-weight: 600;
        font-size: 22px;
        line-height: 28px;
        font-feature-settings: "pnum" on, "onum" on;
        color: #1a1a1c;
        padding-bottom: 5px;
    }

    .description {
        font-family: IRANSans;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 26px;
        letter-spacing: -0.02em;
        color: #1a1a1c;
        padding-bottom: 30px;
    }

    .label {
        font-family: IRANSans;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 26px;
        letter-spacing: -0.02em;
        color: #1a1a1c;
        padding-bottom: 15px;
    }

    .sign-up {
        padding: 80px 130px 60px 130px;
        display: flex;
        align-items: center;
        @media screen and (max-width: 960px) {
            padding: 18px 40px;
        }
        @media screen and (max-width: 320px) {
            padding: 18px 20px;
        }

        .content {
            .sign-up-form {
                padding-top: 120px;

                .form-controls {
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                    
                    @media screen and (max-width: 600px) {
                        display: block;
                    }

                    .control-item {
                        @media screen and (max-width: 600px) {
                            padding: 8px 0;
                        }
                    }

                    .phone-control {
                        min-width: 280px;
                        @media screen and (max-width: 600px) {
                            min-width: 0;
                        }
                    }
                }

                .subscription-message {
                    padding-top: 10px;
                    font-size: 12px;
                    line-height: 20px;

                    &.success {
                        color: #287a45;
                    }

                    &.error {
                        color: #b42318;
                    }
                }
            }
        }

        .calculator-column {
            display: flex;
            justify-content: center;
            padding-right: 30px;
            @media screen and (max-width: 960px) {
                padding-top: 50px;
                padding-right: 0;
            }
        }
    }

    .assets {
        scroll-margin-top: 20px;
        padding: 60px 130px;
        @media screen and (max-width: 1200px) {
            padding: 60px 40px;
        }
        @media screen and (max-width: 320px) {
            padding: 60px 20px;
        }
    }

    .claim {
        display: flex;
        justify-content: center;
        padding-bottom: 80px;

        .main {
            width: 688px;
            height: 228px;
            @media screen and (min-width: 1040px) {
                width: 978px;
                height: 268px;
            }
            @media screen and (max-width: 740px) {
                width: 280px;
                height: 401px;
                display: block !important;
            }
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
            border-radius: 12px;

            img {
                position: absolute;
                top: 0;
                left: 0;
                z-index: -1;
            }

            .image-computer {
                width: 978px;
                height: 268px;
                display: block;
                @media screen and (max-width: 1040px) {
                    display: none;
                }
            }

            .image-pad {
                width: 688px;
                height: 228px;
                display: block;
                @media screen and (min-width: 1040px) {
                    display: none;
                }
                @media screen and (max-width: 740px) {
                    display: none;
                }
            }

            .image-mobile {
                width: 280px;
                height: 401px;
                display: block;
                @media screen and (min-width: 740px) {
                    display: none;
                }
            }

            .claim-content {
                padding-left: 20px;
                max-width: 400px;

                .claim-title {
                    font-family: IRANSans;
                    font-style: normal;
                    font-weight: 500;
                    font-size: 22px;
                    line-height: 30px;
                    letter-spacing: -0.025em;
                    font-feature-settings: "pnum" on, "onum" on;
                    color: #1a1a1c;
                    padding-top: 20px;
                    padding-bottom: 10px;
                }

                .claim-description {
                    font-family: IRANSans;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 18px;
                    line-height: 26px;
                    letter-spacing: -0.02em;
                    color: #1a1a1c;
                }
            }

            .action {
                padding-right: 30px;
                @media screen and (max-width: 740px) {
                    padding: 0 20px;
                }

                .claim-label {
                    text-align: center;
                    font-family: IRANSans;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 18px;
                    line-height: 26px;
                    letter-spacing: -0.02em;
                    color: #1a1a1c;
                    padding-top: 30px;
                }

                .spots {
                    font-family: IRANSans;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 40px;
                    line-height: 46px;
                    text-align: right;
                    letter-spacing: -0.035em;
                    font-feature-settings: "pnum" on, "onum" on;
                    color: #1a1a1c;
                    text-align: center;
                    padding-bottom: 10px;
                    @media screen and (max-width: 740px) {
                        padding-bottom: 40px;
                    }
                }
            }
        }
    }

    .panels {
        display: flex;
        justify-content: center;

        .main {
            width: 688px;
            @media screen and (min-width: 1040px) {
                width: 978px;
            }
            @media screen and (max-width: 740px) {
                width: 280px;
            }

            .panel-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 80px;
                @media screen and (max-width: 740px) {
                    display: block;
                }

                .panel-main {
                    display: flex;
                    @media screen and (max-width: 740px) {
                        display: block;
                    }

                    .rphone-left {
                        display: none;
                        @media screen and (max-width: 1040px) {
                            display: block;
                        }
                        margin-right: 40px;
                    }

                    .lphone-left {
                        display: none;
                        @media screen and (min-width: 1040px) {
                            display: block;
                        }
                        @media screen and (max-width: 740px) {
                            display: block;
                        }
                        margin-right: 40px;
                    }

                    .panel-content {
                        max-width: 479px;
                    }
                }

                .rphone-right {
                    display: none;
                    @media screen and (min-width: 1040px) {
                        display: block;
                    }
                }

                .lphone-right {
                    display: block;
                    @media screen and (min-width: 1040px) {
                        display: none;
                    }
                    @media screen and (max-width: 740px) {
                        display: none;
                    }
                }
            }
        }
    }

    .setup {
        text-align: center;
        padding: 60px 100px 80px 100px;
        @media screen and (min-width: 1040px) {
            padding: 60px 250px 80px 250px;
        }
        @media screen and (max-width: 740px) {
            padding: 40px 20px 80px 20px;
        }

        .setup-item {
            padding-top: 60px;

            .icon {
                img {
                    width: 80px;
                }
            }

            .setup-item-title {
                font-family: IRANSans;
                font-style: normal;
                font-weight: 500;
                font-size: 20px;
                line-height: 28px;
                text-align: center;
                letter-spacing: -0.025em;
                font-feature-settings: "pnum" on, "onum" on;
                color: #1a1a1c;
                padding-top: 35px;
                padding-bottom: 2px;
            }

            .setup-item-description {
                font-family: IRANSans;
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                line-height: 22px;
                text-align: center;
                letter-spacing: -0.01em;
                color: #1a1a1c;
            }
        }
    }

    .rest {
        padding: 0 40px 80px 40px;
        border-radius: 12px;
        @media screen and (min-width: 1040px) {
            padding: 0 130px 80px 130px;
        }
        @media screen and (max-width: 740px) {
            padding: 0 20px 80px 20px;
        }

        .rest-item {
            border: solid 1px rgba(0, 0, 0, 0.15);
            padding: 40px;
            @media screen and (min-width: 1040px) {
                padding: 60px;
            }
            @media screen and (max-width: 740px) {
                padding: 20px;
            }
        }

        .image {
            display: flex;
            justify-content: center;
            align-items: center;

            img.computer {
                width: 400px;
                display: block;
                @media screen and (max-width: 740px) {
                    display: none;
                }
            }

            img.mobile {
                width: 250px;
                display: none;
                @media screen and (max-width: 740px) {
                    display: block;
                }
            }
        }

        .rest-title {
            font-family: IRANSans;
            font-style: normal;
            font-weight: 500;
            font-size: 34px;
            line-height: 40px;
            letter-spacing: -0.035em;
            font-feature-settings: "pnum" on, "onum" on;
            color: #1a1a1c;
            padding-bottom: 30px;
        }

        .item {
            display: flex;
            align-items: center;
            padding-bottom: 25px;

            .icon {
                color: #1a1a1c;
            }

            .rest-description {
                font-family: IRANSans;
                font-style: normal;
                font-weight: normal;
                font-size: 18px;
                line-height: 26px;
                letter-spacing: -0.02em;
                color: #1a1a1c;
            }
        }
    }

    .connect {
        scroll-margin-top: 20px;
        align-items: center;

        .image {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 50px 80px 130px;
            @media screen and (max-width: 992px) {
                padding: 0 40px 32px 40px;
            }
            @media screen and (max-width: 480px) {
                padding: 0 20px 28px 20px;
            }

            img {
                width: 100%;
                max-width: 420px;
                aspect-ratio: 2478 / 3469;
                display: block;
                object-fit: contain;
                object-position: center;
                border-radius: 12px;
                box-shadow: 0 18px 44px rgba(26, 26, 28, 0.14);
                @media screen and (max-width: 992px) {
                    max-width: min(100%, 430px);
                    box-shadow: 0 12px 28px rgba(26, 26, 28, 0.12);
                }
            }
        }

        .connect-content-wrapper {
        }

        .connect-extra-image {
            text-align: center;
            width: 100%;
            margin-top: 0;

            img {
                width: 100% !important; /* Mobile width */
                @media screen and (min-width: 992px) {
                    width: 100% !important; /* Normal size on desktop */
                }
            }

            @media screen and (min-width: 992px) {
                text-align: right;
                padding-right: 20px;
                padding-left: 0;
            }
        }

        .connect-content {
            margin-top: 40px;
            padding: 0 50px 80px 50px;
            direction: rtl;
            @media screen and (min-width: 992px) {
                padding: 0 130px 80px 50px;
            }
            @media screen and (max-width: 768px) {
                padding: 0 20px 80px 20px;
            }

            .title {
                font-size: clamp(28px, 4vw, 40px);
                line-height: 1.25;
                letter-spacing: 0;
                padding-top: 0;
            }

            .description {
                max-width: 620px;
                font-size: clamp(16px, 2.2vw, 18px);
                line-height: 1.8;
                letter-spacing: 0;
            }
        }
    }

    #request {
        scroll-margin-top: 20px;
    }

    .signup-trading {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 50px 80px 50px;
        @media screen and (min-width: 992px) {
            padding: 0 130px 80px 130px;
        }
        @media screen and (max-width: 768px) {
            padding: 0 20px 80px 20px;
            display: block;
        }

        .main {
            display: flex;
            @media screen and (max-width: 740px) {
                display: block;
            }

            .phone-left {
                display: none;
                margin-right: 40px;
                @media screen and (max-width: 1040px) {
                    display: flex;
                    justify-content: center;
                    width: 100%;
                }

                img {
                    box-shadow: rgba(0, 0, 0, 0.25) 0 25px 50px -12px;
                    border-radius: 50px;
                }
            }

            .content {
                max-width: 630px;

                .sign-up-form {
                    padding-top: 30px;

                    .form-controls {
                        display: flex;
                        align-items: center;
                        @media screen and (max-width: 600px) {
                            display: block;
                        }

                        .control-item {
                            padding: 0 8px;
                            @media screen and (max-width: 600px) {
                                padding: 8px 0;
                            }
                        }
                    }
                }
            }
        }

        .phone-right {
            display: none;
            @media screen and (min-width: 1040px) {
                display: flex;
                justify-content: center;
            }

            img {
                box-shadow: rgba(0, 0, 0, 0.25) 0 25px 50px -12px;
                border-radius: 50px;
            }
        }
    }

    .about {
        background: #f5f6f7;
        padding: 50px 30px 110px 30px;
        @media screen and (min-width: 992px) {
            padding: 50px 130px 110px 130px;
        }
        @media screen and (max-width: 768px) {
            padding: 50px 20px 100px 20px;
        }

        .about-header {
            display: flex;
            justify-content: space-between;
            @media screen and (max-width: 1040px) {
                display: block;
            }

            .social {
                display: flex;

                .social-item {
                    margin-right: 20px;
                    width: 40px;
                    height: 40px;
                    background: #1a1a1c;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .social-icon {
                        color: white;
                    }
                }
            }

            .left {
                display: none;
                @media screen and (max-width: 1040px) {
                    display: flex;
                    padding-bottom: 40px;
                }
            }

            .right {
                display: none;
                @media screen and (min-width: 1040px) {
                    display: flex;
                }
            }
        }

        .item {
            padding-top: 70px;
        }

        .about-description {
            font-family: IRANSans;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 22px;
            color: #1a1a1c;
        }

        .contact-details {
            font-size: 16px;
            line-height: 26px;
        }

        .developer-contact {
            position: relative;
            display: inline-block;
            cursor: pointer;
            text-decoration: none;
            color: unset;

            .developer-phone {
                position: absolute;
                bottom: calc(100% + 8px);
                left: 50%;
                z-index: 2;
                padding: 6px 10px;
                border-radius: 6px;
                background: #1a1a1c;
                color: #ffffff;
                direction: ltr;
                opacity: 0;
                pointer-events: none;
                text-decoration: none;
                transform: translate(-50%, 5px);
                transition: opacity 0.2s ease, transform 0.2s ease;
                white-space: nowrap;
            }

            &:hover .developer-phone,
            &:focus .developer-phone,
            &:focus-within .developer-phone {
                opacity: 1;
                pointer-events: auto;
                transform: translate(-50%, 0);
            }
        }

        .detail {
            padding-top: 40px;
        }
    }
`;
